import type {ButtonProps} from '@yandex-delivery/blocks'
import {PaymentCard} from '@yandex-delivery/api/model/payment'
import {useCallback} from 'react'

import type {PaymentCardErrorCode} from '../../../../../../../api/payment'
import {usePaymentCardErrorButtonProps} from '../hooks/usePaymentCardErrorButtonProps'

export type UseButtonPropsReturn = {
  cardErrorCode?: PaymentCardErrorCode
  onPress?: VoidFunction
  paymentCard?: PaymentCard
}

export function useButtonProps({onPress, paymentCard, cardErrorCode}: UseButtonPropsReturn): ButtonProps {
  const handleOpenChangeCardModal = useCallback(() => {
    onPress?.()
  }, [onPress])

  return Object.assign<ButtonProps, ButtonProps | undefined>(
    {
      onPress: handleOpenChangeCardModal,
      shape: 'circle',
      textVariant: 'caption1',
      type: 'button',
      variant: 'ghost',
    },
    usePaymentCardErrorButtonProps(cardErrorCode),
  )
}
